'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackApiResult = exports.trackApiRequest = exports.flush = exports.histogram = exports.increment = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queue = [];
var flushTimer = void 0;

var flush = function flush() {
  if (__SERVER__) {
    throw new Error('cannot flush() on the server');
  }

  if (!queue.length) {
    return;
  }

  var request = new XMLHttpRequest();
  request.open('POST', '/_jot', true);
  request.setRequestHeader('Content-Type', 'application/json');
  request.send((0, _stringify2.default)(queue));
  queue.length = 0;
};

var debouncedFlush = function debouncedFlush() {
  if (flushTimer) {
    clearTimeout(flushTimer);
  }
  flushTimer = setTimeout(function () {
    flush();
    flushTimer = null;
  }, 250);
};

var sanitizeForGraphite = function sanitizeForGraphite(str) {
  return String(str).replace(/\./, '-');
};
var prefix = function prefix(client) {
  return (client ? client + '.' : '') + 'api';
};

var increment = function increment(name) {
  if (__SERVER__ && global.statsd) {
    global.statsd.increment(name);
  } else if (__CLIENT__) {
    queue.push(['increment', name]);
    debouncedFlush();
  }
};

var histogram = function histogram(name, duration) {
  if (__SERVER__ && global.statsd) {
    global.statsd.histogram(name, duration);
  } else if (__CLIENT__) {
    queue.push(['histogram', name, duration]);
    debouncedFlush();
  }
};

var trackApiRequest = function trackApiRequest(client, event) {
  if (!event || !event.method || !event.name) {
    console.warn('Cannot log event', event); // eslint-disable-line no-console
    return;
  }

  // counter: <namespace>.<client name>.api.<name>.requested
  // counter: <namespace>.<client name>.api._global.requested
  increment(prefix(client) + '.' + event.method.toLowerCase() + '.' + sanitizeForGraphite(event.name.toLowerCase()) + '.requested');
  increment(prefix(client) + '.' + event.method.toLowerCase() + '._global.requested');
};

var trackApiResult = function trackApiResult(client, event) {
  if (!event || !event.method || !event.name) {
    console.warn('Cannot log event', event); // eslint-disable-line no-console
    return;
  }
  // timer: <namespace>.<client name>.api.<verb>.<name>.response_time
  // timer: <namespace>.<client name>.api.<verb>._global.response_time
  histogram(prefix(client) + '.' + event.method.toLowerCase() + '.' + sanitizeForGraphite(event.name.toLowerCase()) + '.response_time', event.duration);
  histogram(prefix(client) + '.' + event.method.toLowerCase() + '._global.response_time', event.duration);

  // counter: <namespace>.<client name>.api.<verb>.<name>.http.<code>
  // counter: <namespace>.<client name>.api.<verb>._global.http.<code>
  if (event.httpStatus) {
    increment(prefix(client) + '.' + event.method.toLowerCase() + '.' + sanitizeForGraphite(event.name.toLowerCase()) + '.http.' + event.httpStatus);
    increment(prefix(client) + '.' + event.method.toLowerCase() + '._global.http.' + event.httpStatus);
  }

  // counter: <namespace>.<client name>.api.<verb>.<name>.error.<code>
  // counter: <namespace>.<client name>.api.<verb>._global.error.<code>
  if (event.code) {
    increment(prefix(client) + '.' + event.method.toLowerCase() + '.' + sanitizeForGraphite(event.name.toLowerCase()) + '.error.' + event.code);
    increment(prefix(client) + '.' + event.method.toLowerCase() + '._global.error.' + event.code);
  }
};

exports.increment = increment;
exports.histogram = histogram;
exports.flush = flush;
exports.trackApiRequest = trackApiRequest;
exports.trackApiResult = trackApiResult;